import { render } from "./StreamingEnd.vue?vue&type=template&id=355c3bd8&scoped=true"
import script from "./StreamingEnd.vue?vue&type=script&lang=js"
export * from "./StreamingEnd.vue?vue&type=script&lang=js"

import "./StreamingEnd.vue?vue&type=style&index=0&id=355c3bd8&scoped=true&lang=css"

import exportComponent from "/Users/xueke/Develop/Work/rococo/weshow-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355c3bd8"]])

export default __exports__